<template>
  <div class="d-block d-md-flex justify-start">
    <v-btn
        :loading="loading"
        :disabled="!canPreviousStep"
        class="btn-cancel"
        @click.prevent="$emit('previousStep')"
        text
    >Cancelar
    </v-btn>
    <v-btn
        :loading="loading"
        :disabled="!canNextStep"
        class="btn-confirm"
        @click.prevent="$emit('nextStep')"
        text
    >Avançar
    </v-btn>
  </div>
</template>

<script>

export default {
  name: "ActionFooter",
  components: {
    //
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    canNextStep: {
      type: Boolean,
      default: false,
    },
    canPreviousStep: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {};
  },
  methods: {
    //
  },
  computed: {
    //
  }
}
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .btn-confirm, .btn-cancel {
    width: 100%;
    margin: 5px 0 !important;
    padding: 0;

  }
}
</style>
